// extracted by css-extract-rspack-plugin
export default {"info":"_98212af7","associations":"_9c9f533","compact":"_48483b7e","associationsList":"_eb2c2e31"};